import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../stylesheets/application.css"
import { initCopyButtons } from "../modules/copyButtons"

Rails.start()
ActiveStorage.start()
document.addEventListener("DOMContentLoaded", initCopyButtons)
